<div mat-dialog-content>
  <b>
    <p>Are you sure you would like to {{action}} this form?</p>
  </b>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No</button>
  <button mat-button [mat-dialog-close]="action" cdkFocusInitial>Yes</button>
</div>